import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TOrderAttributesState } from './order-attributes.models';

export const getOrderAttributesState = (state: TPlani8State) => state.orderAttributesInfo;

export const getOrderAttributesInfo = createSelector(
  getOrderAttributesState,
  (state: TOrderAttributesState) => state.OrderAttributesInfo,
);

export const getOrderAttributesTypesInfo = createSelector(
  getOrderAttributesState,
  (state: TOrderAttributesState) => state.OrderAttributesTypesInfo,
);
